import React from 'react';
import PropTypes from 'prop-types';
import Maybe from 'react-maybe';
import { Typo } from '@ers/ui/';
import { Section, PhoneFormatted } from '..';

const PersonalData = ({ form, translations }) => {
    const data = form.personalData;
    return (
        <>
            <Typo.Subheader>{translations.personalData}</Typo.Subheader>
            <Maybe
                of={data.order}
                either={(
                    <Section>
                        {({ renderField }) => (
                            <>
                                {renderField(translations.firstName, data.firstName)}
                                {renderField(translations.lastName, data.lastName)}
                                {renderField(translations.email, data.email)}
                                {renderField(translations.phone, data.phoneNumber, (phone) => (
                                    <PhoneFormatted>{phone}</PhoneFormatted>
                                ))}
                            </>
                        )}
                    </Section>
                )}
                orElse={null}
            />

        </>
    );
};
PersonalData.propTypes = {
    form: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default PersonalData;
